import { createElement } from 'react';

import { Label } from 'components';
import { useCatalogTranslation } from 'hooks';
import {
  dateFormat,
  dateTimeFormat,
  linkFormat,
  numberFormat,
} from 'utils/formater';
import { pickValue } from 'utils/objects';

function useTable(config) {
  const catalogTranslation = useCatalogTranslation();

  const getRows = function (headers, data = [], extras) {
    const rows = Array.isArray(data) ? data : [];

    return rows.map((row, index) => ({
      data: row,
      id: pickValue(row, config?.id || 'id') ?? index,
      values: headers.map((header) => {
        const align = header?.align || 'center';
        const name = header?.name;
        let type = header?.type;
        let label = typeof header?.get === 'function'
          ? header.get(row)
          : pickValue(row, header.name);

        switch (header.type) {
          default: { break; }

          case 'label': {
            switch (header?.format) {
              default: { break; }

              case 'percentage': {
                type = 'percentage';

                break;
              }
            }

            break;
          }

          case 'date': {
            label = dateFormat(label);

            break;
          }

          case 'datetime': {
            label = dateTimeFormat(
              label,
              header.format,          // Estaba harcodeado con 'undefined', sale igual si se manda o no el valor.
              header.local ?? true,   // En el caso de CallTabs el endpoint manda ya el valor en horario local, por lo que se pone la alternativa de poner false.
            );

            break;
          }


          case 'number': {
            let format = undefined;
            let prefix = undefined;

            switch (header?.format) {
              default: { break; }

              case 'currency':
              case 'money': {
                prefix = '$';

                break;
              }

              case 'percentage': {
                format = '0,0.00 %';
                type = 'percentage';

                break;
              }
            }

            label = numberFormat(label, prefix, format);

            break;
          }

          case 'link': {
            label = linkFormat(label);

            break;
          }
        }

        if (typeof header.render === 'function') {
          label = header.render(label, row, extras);
        }

        if (header.catalog && typeof label === 'string') {
          label = catalogTranslation(label, ...header.catalog.split('.'), header.emptyLabel);
        }

        if (label === null && header.name === 'info.reference_date') {
          label = 'No definida';
        }

        if (header.name === 'type') {
          if (label === 'default') {
            label = 'Por defecto';
          }
          if (label === 'client') {
            label = 'Cliente';
          }
          if (label === 'relations') {
            label = 'Relación';
          }
        }

        switch (header.component) {
          default: { break; }

          case 'label': {
            let color;

            if (typeof header?.color === 'function') {
              color = header.color(pickValue(row, header.name), row);
            } else {
              color = header?.color
                ? header?.color[pickValue(row, header.name)]
                : undefined;
            }

            label = createElement(Label, {
              color,
              children: label,
            });
            break;
          }
        }

        return {
          align,
          label,
          name,
          type,
        };
      }),
    }));
  };

  const generateTable = function (headers, data = [], extras = {}) {

    const getHeaderLabel = function (header) {
      if (header.label) {
        return header.label;
      } else if (header.name) {
        return typeof config?.translate === 'function'
          ? config?.translate('table.headers.'.concat(header.name))
          : header.name;
      } else {
        return '';
      }
    };

    return {
      headers: (Array.isArray(headers) ? headers : []).map((header) => ({
        label: getHeaderLabel(header),
        name: header.name,
        align: header.align || 'center',
        collapsible: !!header.collapsible,
        subheader: header.subheader,
      })),
      rows: getRows(headers, data, extras),
    };
  };

  return {
    getRows,
    generateTable,
  };
}

export default useTable;
